/**
 * @generated SignedSource<<8720e5e3d9568a414f33677cd2eb69ef>>
 * @relayHash 7e4f7d86cd2479b4f622c02d8e0c509f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7e4f7d86cd2479b4f622c02d8e0c509f

import type { ConcreteRequest } from 'relay-runtime';
export type CreateMilestoneInput = {
  clientMutationId?: string | null | undefined;
  description?: string | null | undefined;
  dueOn?: string | null | undefined;
  repositoryId: string;
  title: string;
};
export type createMilestoneRelayMutation$variables = {
  input: CreateMilestoneInput;
};
export type createMilestoneRelayMutation$data = {
  readonly createMilestone: {
    readonly milestone: {
      readonly closed: boolean;
      readonly closedAt: string | null | undefined;
      readonly dueOn: string | null | undefined;
      readonly id: string;
      readonly progressPercentage: number;
      readonly title: string;
      readonly url: string;
    } | null | undefined;
  } | null | undefined;
};
export type createMilestoneRelayMutation$rawResponse = {
  readonly createMilestone: {
    readonly milestone: {
      readonly closed: boolean;
      readonly closedAt: string | null | undefined;
      readonly dueOn: string | null | undefined;
      readonly id: string;
      readonly progressPercentage: number;
      readonly title: string;
      readonly url: string;
    } | null | undefined;
  } | null | undefined;
};
export type createMilestoneRelayMutation = {
  rawResponse: createMilestoneRelayMutation$rawResponse;
  response: createMilestoneRelayMutation$data;
  variables: createMilestoneRelayMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMilestonePayload",
    "kind": "LinkedField",
    "name": "createMilestone",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Milestone",
        "kind": "LinkedField",
        "name": "milestone",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressPercentage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createMilestoneRelayMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createMilestoneRelayMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7e4f7d86cd2479b4f622c02d8e0c509f",
    "metadata": {},
    "name": "createMilestoneRelayMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "97ffc61ba733eabd326a47f31d404352";

export default node;
